<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="品质鉴定" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="质量鉴定" >
                <el-select v-model="formData.qualityIdentify" style="width:10vw!important;" :disabled="able" @change="getIdentifyResult"
                  clearable>
                  <el-option v-for="item in qualityIdentifyList" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="责任鉴定" >
                <el-select v-model="formData.responsibilityIdentify" style="width:10vw!important;" :disabled="able"
                  clearable>
                  <el-option v-for="item in responsibilityIdentifyList" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否可维修" >
                <el-select v-model="formData.canFix" clearable :disabled="able" style="width:10vw!important;">
                  <el-option :value="0" label="否"></el-option>
                  <el-option :value="1" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="鉴定结果" >
                <el-input type="text" autocomplete="off" v-model="formData.identifyResultName" :disabled="able" clearable />
              </el-form-item>
              <el-form-item label="备注" >
                <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  :diabled="siteAppealButton" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'exchangeOrderNo', 'exchangeOrderId',],
  created() {
    this.formData.id = this.exchangeOrderId
  },
  data() {
    return {
      uploadFileUrl: api.uploadFileUrl,

      identifyResultList: [],
      identifyResultFilterList: [],
      qualityIdentifyList: [],
      responsibilityIdentifyList: [],
      exchangeNo: '',

      siteAppealButton: false,

      formData: {
        id: null,
        qualityIdentify: null,
        qualityIdentifyName: null,
        identifyResult: null,
        identifyResultName: null,
        responsibilityIdentify: null,
        responsibilityIdentifyName: null,
        canFix: 0,
        messageContent:null,
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    getIdentifyResult() {
      let qualityIdentifyName = '';
      let qualityIdentify = this.formData.qualityIdentify;
      if (qualityIdentify) {
        this.qualityIdentifyList.forEach(item => {
          if (qualityIdentify === item.value) {
            qualityIdentifyName = item.label
          }
        })
      }

      this.formData.identifyResult = null
      this.formData.identifyResultName = ""

      console.log("getIdentifyResult")
      this.identifyResultFilterList = []
      this.identifyResultList.forEach(item => {
        console.log("item.lable" + item.label)
        console.log(item)
        if (item.label.startsWith(qualityIdentifyName)) {
          this.identifyResultFilterList.push({
            label: item.label,
            value: item.value
          })
        }
      })
    },
    // 考核的确认
    siteAppeal() {
      let qualityIdentify = this.formData.qualityIdentify;
      if (qualityIdentify) {
        this.qualityIdentifyList.forEach(item => {
          if (qualityIdentify === item.value) {
            this.formData.qualityIdentifyName = item.label
          }
        })
      }
      let identifyResult = this.formData.identifyResult;
      if (identifyResult) {
        this.identifyResultList.forEach(item => {
          if (identifyResult === item.value) {
            this.formData.identifyResultName = item.label
          }
        })
      }
      let responsibilityIdentify = this.formData.responsibilityIdentify;
      if (responsibilityIdentify) {
        this.responsibilityIdentifyList.forEach(item => {
          if (responsibilityIdentify === item.value) {
            this.formData.responsibilityIdentifyName = item.label
          }
        })
      }
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: "/basic/wkExchangeOrder/qualityCheck",
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('确认成功')
          this.$emit('closeDialog',true)
        }).catch(() => {
          this.$mask.close()
        })
      })
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      loadDictData("鉴定结果").then(res => {
        this.identifyResultList = []
        res.data.data.forEach(item => {
          this.identifyResultList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("质量鉴定").then(res => {
        this.qualityIdentifyList = []
        let defaultQualityIdentify = null
        res.data.data.forEach(item => {
          this.qualityIdentifyList.push({
            label: item.label,
            value: item.id
          })
          if (item.label === "质量问题") {
            defaultQualityIdentify = item.id;
          }
        })
        if (defaultQualityIdentify) {
          this.formData.qualityIdentify = defaultQualityIdentify
        }
      })
      loadDictData("责任鉴定").then(res => {
        this.responsibilityIdentifyList = []
        let defaultResponsibilityIdentify = null
        res.data.data.forEach(item => {
          this.responsibilityIdentifyList.push({
            label: item.label,
            value: item.id
          })
          if (item.label === "华帝责任") {
            defaultResponsibilityIdentify = item.id;
          }
        })
        if (defaultResponsibilityIdentify) {
          this.formData.responsibilityIdentify = defaultResponsibilityIdentify
        }
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeDialog', false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
